/**
 * Fixture props with config_json.options use config-based picks (numeric / labeled),
 * not the classic under/over pair, or boolean.
 */
export function getFixturePropConfigBasedOptions(prop) {
  const raw = prop && prop.config_json && prop.config_json.options;
  if (!Array.isArray(raw) || raw.length === 0) {
    return null;
  }
  return raw;
}

// Check if the prop has config-based options
export function hasFixturePropConfigBasedOptions(prop) {
  return getFixturePropConfigBasedOptions(prop) != null;
}

// Check if the participant has already chosen that option
export function fixturePropPicksEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a == null || b == null) {
    return false;
  }
  if (typeof a === 'number' || typeof b === 'number') {
    return Number(a) === Number(b);
  }
  return String(a) === String(b);
}
